import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, Redirect } from "react-router-dom";

import { Header, Footer, Sidebar } from "components";

import dashboardRoutes from "routes/dashboard.jsx";
import Bills from "views/Bills/BillsList.jsx";
import BillDetail from "views/Bills/BillDetail.jsx";
import Mobiles from "views/Mobiles/MobilesList.jsx";
import MobileDetail from "views/Mobiles/MobileDetail.jsx";
import DashboardPanel from "views/Dashboard/Dashboard.jsx";
import Tools from "views/Tools/Tools.jsx";
import Apps from "views/Apps/Apps.jsx";
import LoginPage from "layouts/Pages/Pages.jsx";
import Contract from "views/Contract/Contract.jsx";
import ViewContract from "../../views/Contract/ViewContract";

var ps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    //this.startLogin = this.startLogin.bind(this);
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(this.refs.mainPanel);
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.documentElement.className += " perfect-scrollbar-off";
      document.documentElement.classList.remove("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }
  render() {
    return (
      <div className="wrapper">
        {/* <Sidebar {...this.props} routes={dashboardRoutes} /> */}
        <div className="main-panel" ref="mainPanel">
          <Switch>
            <Route
              exact
              path="/"
              render={(props) => (
                <Contract
                  {...props}
                  state={this.props.state}
                  closeContract={this.props.closeContract}
                  showNotification={this.props.showNotification}
                />
              )}
            />
            <Route
              path="/ver/:id"
              render={(props) => (
                <ViewContract
                  {...props}
                  // state={this.props.state}
                  // closeContract={this.props.closeContract}
                  // showNotification={this.props.showNotification}
                />
              )}
            />
          </Switch>
          <Footer fluid />
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx